export const measureLegendWidth = (labels: string[], fontSize: number) => {
  if (typeof window === 'undefined' || labels.length === 0) return 0;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return 0;

  ctx.font = `${fontSize}px sans-serif`;

  const iconSize = 12;
  const iconGap = 6;
  const sidePadding = 5;

  const maxTextWidth = Math.max(...labels.map(label => ctx.measureText(label).width));

  return Math.ceil(iconSize + iconGap + maxTextWidth + sidePadding * 2);
}
